import React from 'react';
import UploadErrorComponent from '@cp/src/components/UploadComponent/UploadErrorComponent';
import UploadSuccessComponent from '@cp/src/components/UploadComponent/UploadSuccessComponent';
import { UploadedFileStatesProps } from '../../pages/AllocationServices/BulkUpload/interfaces';

const UploadedFileStates: React.FC<UploadedFileStatesProps> = ({
  error,
  file,
  setFile,
  setError,
  showLoadingComponent,
  setShowLoadingComponent
}) => {
  const hasErrorState = error?.message;
  const hasNoState = !hasErrorState && !file;
  const hasLoadingState = !hasErrorState && file && showLoadingComponent;

  if (hasNoState) {
    return <div></div>;
  }

  if (hasErrorState) {
    return (
      <UploadErrorComponent
        containerClassName="flex items-center mr-3 mb-3 !mb-1"
        message={error?.message}
        fileName={error?.fileName || ''}
        showRetryIcon={false}
        showValidationText
        onCancel={() => {
          setError({ message: '', fileName: '' });
          setFile(null);
        }}
        messageClassName="!ml-4 !mt-0"
      />
    );
  }

  if (hasLoadingState) {
    return (
      <UploadSuccessComponent
        containerClassName="mr-3 mb-3"
        name={file?.name || ''}
        isInProgress={true}
        onCancel={() => {
          setFile(null);
          setShowLoadingComponent(false);
        }}
        showCancelIcon={false}
      />
    );
  }

  return (
    <UploadSuccessComponent
      containerClassName="mr-3 mb-3"
      name={file?.name as string}
      isInProgress={false}
      onCancel={() => {
        setFile(null);
      }}
    />
  );
};

export default UploadedFileStates;
